import { whatsappConversationSharedLocalizations } from '../../../shared/whatsappConversationLocalizations';

export const localization = {
  pt: {
    locale: 'pt-BR',
    header: {
      title: 'Mensagens via WhatsApp',
      description: whatsappConversationSharedLocalizations.pt.disclaimers.whatsappDataDisclaimer,
      showMoreButton: 'Ver mais',
      tooltipText:
        'São trocas de mensagem via WhatsApp entre empresas e usuários. Uma conversa inclui todas as mensagens trocadas dentro de um período de 24 horas, começando quando a primeira mensagem enviada pela empresa é entregue.',
    },
    leftChart: {
      title: 'Consumo de Mensagens',
      label: 'Total mensagens',
      customLabels: {
        freeEntryPoint: whatsappConversationSharedLocalizations.pt.labels.freeEntryPoint,
        freeCustomerService: whatsappConversationSharedLocalizations.pt.labels.freeCustomerService,
        charged: whatsappConversationSharedLocalizations.pt.labels.charged,
      },
    },
    leftInfoPaper: {
      totalFreeTier: {
        description: whatsappConversationSharedLocalizations.pt.descriptions.freeTierUsage,
        tooltipText: whatsappConversationSharedLocalizations.pt.conversationTooltips.freeTier,
      },
      totalFreeEntryPoint: {
        description: whatsappConversationSharedLocalizations.pt.labels.freeEntryPoint,
      },
      totalFreeCustomerService: {
        description: whatsappConversationSharedLocalizations.pt.labels.freeCustomerService,
      },
      totalRegular: {
        description: whatsappConversationSharedLocalizations.pt.descriptions.chargedConversations,
      },
    },
    rightChart: {
      period: '{startDate} a {endDate}',
      title: 'Origem das conversas',
      customLabels: {
        businessInitiated: whatsappConversationSharedLocalizations.pt.labels.businessInitiated,
        userInitiated: whatsappConversationSharedLocalizations.pt.labels.userInitiated,
        total: whatsappConversationSharedLocalizations.pt.labels.totalConversations,
      },
    },
    rightInfoPaper: {
      total: {
        description: whatsappConversationSharedLocalizations.pt.labels.totalConversations,
      },
      totalBusinessInitiated: {
        description: whatsappConversationSharedLocalizations.pt.descriptions.totalBusinessInitiated,
      },
      totalUserInitiated: {
        description: whatsappConversationSharedLocalizations.pt.descriptions.totalUserInitiated,
      },
    },
  },
  en: {
    locale: 'en-US',
    header: {
      title: 'Messages via WhatsApp',
      description: whatsappConversationSharedLocalizations.en.disclaimers.whatsappDataDisclaimer,
      showMoreButton: 'See more',
      tooltipText:
        'WhatsApp messages exchanged between companies and users. Conversations include all messages exchanged within a 24-hour span, starting when the first message sent by the company is delivered.',
    },
    leftChart: {
      title: 'Message usage',
      label: 'Messages total',
      customLabels: {
        freeEntryPoint: whatsappConversationSharedLocalizations.en.labels.freeEntryPoint,
        freeCustomerService: whatsappConversationSharedLocalizations.en.labels.freeCustomerService,
        charged: whatsappConversationSharedLocalizations.en.labels.charged,
      },
    },
    leftInfoPaper: {
      totalFreeTier: {
        description: whatsappConversationSharedLocalizations.en.descriptions.freeTierUsage,
        tooltipText: whatsappConversationSharedLocalizations.en.conversationTooltips.freeTier,
      },
      totalFreeEntryPoint: {
        description: whatsappConversationSharedLocalizations.en.labels.freeEntryPoint,
      },
      totalFreeCustomerService: {
        description: whatsappConversationSharedLocalizations.en.labels.freeCustomerService,
      },
      totalRegular: {
        description: whatsappConversationSharedLocalizations.en.descriptions.chargedConversations,
      },
    },
    rightChart: {
      period: '{startDate} to {endDate}',
      title: 'Origin',
      customLabels: {
        businessInitiated: whatsappConversationSharedLocalizations.en.labels.businessInitiated,
        userInitiated: whatsappConversationSharedLocalizations.en.labels.userInitiated,
        total: whatsappConversationSharedLocalizations.en.labels.totalConversations,
      },
    },
    rightInfoPaper: {
      total: {
        description: whatsappConversationSharedLocalizations.en.labels.totalConversations,
      },
      totalBusinessInitiated: {
        description: whatsappConversationSharedLocalizations.en.descriptions.totalBusinessInitiated,
      },
      totalUserInitiated: {
        description: whatsappConversationSharedLocalizations.en.descriptions.totalUserInitiated,
      },
    },
  },
  es: {
    locale: 'es-ES',
    header: {
      title: 'Mensajes por WhatsApp',
      description: whatsappConversationSharedLocalizations.es.disclaimers.whatsappDataDisclaimer,
      showMoreButton: 'Ver más',
      tooltipText:
        'Intercambio de mensajes de WhatsApp entre empresas y usuarios. Las conversaciones incluyen todos los mensajes intercambiados dentro de un período de 24 horas, a partir de la entrega del primer mensaje enviado por la empresa.',
    },
    leftChart: {
      title: 'Consumo de mensajes',
      label: 'mensajes totales',
      customLabels: {
        freeEntryPoint: whatsappConversationSharedLocalizations.es.labels.freeEntryPoint,
        freeCustomerService: whatsappConversationSharedLocalizations.es.labels.freeCustomerService,
        charged: whatsappConversationSharedLocalizations.es.labels.charged,
      },
    },
    leftInfoPaper: {
      totalFreeTier: {
        description: whatsappConversationSharedLocalizations.es.descriptions.freeTierUsage,
        tooltipText: whatsappConversationSharedLocalizations.es.conversationTooltips.freeTier,
      },
      totalFreeEntryPoint: {
        description: whatsappConversationSharedLocalizations.es.labels.freeEntryPoint,
      },
      totalFreeCustomerService: {
        description: whatsappConversationSharedLocalizations.es.labels.freeCustomerService,
      },
      totalRegular: {
        description: whatsappConversationSharedLocalizations.es.descriptions.chargedConversations,
      },
    },
    rightChart: {
      period: '{startDate} a {endDate}',
      title: 'Origen de las conversaciones',
      customLabels: {
        businessInitiated: whatsappConversationSharedLocalizations.es.labels.businessInitiated,
        userInitiated: whatsappConversationSharedLocalizations.es.labels.userInitiated,
        total: whatsappConversationSharedLocalizations.es.labels.totalConversations,
      },
    },
    rightInfoPaper: {
      total: {
        description: whatsappConversationSharedLocalizations.es.labels.totalConversations,
      },
      totalBusinessInitiated: {
        description: whatsappConversationSharedLocalizations.es.descriptions.totalBusinessInitiated,
      },
      totalUserInitiated: {
        description: whatsappConversationSharedLocalizations.es.descriptions.totalUserInitiated,
      },
    },
  },
};
